import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchAdminFranchiseListings } from '../../state/actions/franchise';
import franchiseService from '../../common/services/franchiseService';
import AdminActionModal from '../../common/components/AdminActionModal';
import withReactContent from 'sweetalert2-react-content';
import profileType from './../../common/utils/profileType';
import profileStatus from './../../common/utils/profileStatus';
import Swal from 'sweetalert2';
import { spacePascalWord } from './../../common/utils/helpers';

class FranchiseListingTableItem extends Component {
  MySwal = withReactContent(Swal);
  state = {};

  approveFranchiseListing = async id => {
    Swal.fire(
      'Are you sure?',
      'Do you want to approve listing?',
      'question',
    ).then(async value => {
      if (!value) return;
      const res = await franchiseService.approveFranchiseListing(id);
      if (res) {
        this.props.fetchAdminFranchiseListings();
        Swal.fire('Listing Approved Successfully', '', 'success');
      } else {
        Swal.fire('Unable to approve listing', '', 'error');
      }
    });
  };

  disapproveFranchiseListing = async id => {
    Swal.fire(
      'Are you sure?',
      'Do you want to disapprove listing?',
      'question',
    ).then(async value => {
      if (!value) return;
      const res = await franchiseService.disapproveFranchiseListing(id);
      if (res) {
        this.props.fetchAdminFranchiseListings();
        Swal.fire('Listing Disapproved Successfully', '', 'success');
      } else {
        Swal.fire('Unable to disapprove listing', '', 'error');
      }
    });
  };

  changeListingStatus = async (status, id) => {
    this.MySwal.fire({
      customClass: 'bg-transparent w-lg-30 w-md-30 w-90',
      showConfirmButton: false,
      html: (
        <AdminActionModal
          action={status}
          profileType={profileType.Franchise}
          profileId={id}
          refreshListings={this.props.fetchAdminFranchiseListings}
        ></AdminActionModal>
      ),
    });
  };

  render() {
    const { listing, number } = this.props;
    return (
      <tr>
        <td>
          <Link to={`/user/franchises/${listing.id}`}>{number}</Link>
        </td>
        <td>
          <Link to={`/user/franchises/${listing.id}`}>{listing.id}</Link>
        </td>
        <td>
          <Link to={`/user/franchises/${listing.id}`}>{listing.brandName}</Link>
        </td>
        <td>{listing.hqLocation}</td>
        <td>
          {listing.createdAt && new Date(listing.createdAt).toLocaleString()}
        </td>
        <td>
          <div className="d-flex">
            <span
              className={
                listing.status === profileStatus.Approved
                  ? 'badge badge-success mx-4'
                  : listing.status === profileStatus.Draft ||
                    listing.status === profileStatus.Declined
                  ? 'badge badge-danger mx-4'
                  : listing.status === profileStatus.Pending ||
                    listing.status === profileStatus.ChangesRequired
                  ? 'badge badge-warning mx-4'
                  : 'badge'
              }
            >
              {spacePascalWord(listing.status)}
            </span>
            <button
              className="d-block pr-3 border-0 bg-transparent text-primary"
              id={`${listing.id}`}
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right">
              {listing.isApproved && (
                <button
                  className="dropdown-item cursor-pointer"
                  onClick={() => this.disapproveFranchiseListing(listing.id)}
                >
                  Disapprove
                </button>
              )}
              {!listing.isApproved && (
                <button
                  className="dropdown-item cursor-pointer"
                  onClick={() => this.approveFranchiseListing(listing.id)}
                >
                  Approve
                </button>
              )}
              <button
                className="dropdown-item cursor-pointer"
                onClick={() => this.changeListingStatus('Decline', listing.id)}
              >
                Decline
              </button>
              <button
                className="dropdown-item cursor-pointer"
                onClick={() =>
                  this.changeListingStatus('Request Change', listing.id)
                }
              >
                Request Change
              </button>
            </div>
          </div>
        </td>
        <td>{listing.firstName}</td>
        <td>{listing.lastName}</td>

        <td>{listing.officialEmail}</td>
        <td>{listing.phoneNumber}</td>
        <td>{listing.designation}</td>
        <td>{listing.plan}</td>
        <td>
          <Link to={`/admin/dashboard/user-listings/${listing.id}`}>
            {listing.firstName}
          </Link>
        </td>
        <td>
          <Link to={`/admin/dashboard/user-listings/${listing.id}`}>
            {listing.lastName}
          </Link>
        </td>
      </tr>
    );
  }
}

export default connect(null, { fetchAdminFranchiseListings })(
  FranchiseListingTableItem,
);
